import { ComponentMultiStyleConfig } from '@chakra-ui/react';

export const Accordion: ComponentMultiStyleConfig = {
  parts: ['root', 'container', 'button', 'panel', 'icon'],
  baseStyle: {
    container: {
      '& .chakra-collapse': {
        overflow: 'visible !important',
      },
    },
  },
};
